import {
    AdditionalRoomIcon,
    HomeIcon,
    MapMarkerOutlineIcon,
    MegaphoneIcon,
    PoiShopIcon,
    PriceIcon,
    ProgressIcon,
    ScreenProgressIcon
} from "@pg-design/icons";

import {RegionIcon} from "./RegionIcon";

export const getSideMenuIcon = (name: string, fill = "#fff", size = "2.4") => {
    switch (name) {
        case "home":
            return <HomeIcon size={size} fill={fill} />;
        case "region":
            return <RegionIcon size={size} color={fill} />;
        case "place":
            return <MapMarkerOutlineIcon size={size} fill={fill} />;
        case "euro":
            return <PriceIcon size={size} fill={fill} />;
        case "home_work":
            return <AdditionalRoomIcon size={size} fill={fill} />;
        case "trending_up":
            return <ProgressIcon size={size} fill={fill} />;
        case "fltr":
            return <ScreenProgressIcon size={size} fill={fill} />;
        case "work_outline":
            return <PoiShopIcon size={size} fill={fill} />;
        case "flag":
            return <MegaphoneIcon size={size} fill={fill} />;
        default:
            throw new Error("Invalid SideMenu icon name");
    }
};
